//
//
//
//
import DeviceInfoList from "./DeviceInfoList";
export default {
  components: {
    DeviceInfoList: DeviceInfoList
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  computed: {},
  methods: {}
};